import {createElement, Component, PropTypes} from 'rlink-react';
import {FormattedMessage} from 'react-intl';
import Main from 'components/main';
import css from 'static/style/dow.less';
import fontAwesome from 'rlink-lesscore/icons/font-awesome.less';
import {FeaturedStories, LatestStories} from 'rlink-blog/component';

import {DOW} from 'terms';
import Tabs from 'rlink-tabs/components/Tabs';
import Tab from 'rlink-tabs/components/Tab';
import navActions from 'rlink-router/actions';
import {fromJS} from 'immutable';
import GameUpdateList from 'rlink-blog/GameUpdateList';
import DocumentTitle from 'rlink-react-document/DocumentTitle.jsx';
import DocumentOpenGraphProperty from 'rlink-react-document/DocumentOpenGraphProperty.jsx';

const MINIMUM_EXTRA_ARTICLES = 4;
const DEFAULT_NEWS_TAB = 'all';

export default function (params, content) {
  let items = content.articles.data.get('items').toJS();
  let articles;
  let gameUpdates = items.filter(article => article.articleType === 'patch-notes');
  if (params.filter === 'news') {
    articles = items.filter(article => !('articleType' in article) || article.articleType === 'news-post');
  } else if (params.filter === 'patches') {
    articles = gameUpdates;
  } else {
    articles = items;
  }

  let title = <FormattedMessage
    id="ui.label.title.NEWS_PAGE"
    defaultMessage="News"
    description="Title of the news page." />;
  let description = <FormattedMessage
    id="ui.text.info.NEWS_PAGE_DESCRIPTION"
    defaultMessage="Latest Dawn of War-related news"
    description="Description of the news page." />;
  let signIn = <FormattedMessage
    id="ui.label.button.NEWSLETTER_SIGN_IN_LINK_TEXT"
    defaultMessage="Sign In"
    description="Part of the sign in button text. Gets linked to another page." />;

  let sharedTabContents = <div className={css['news-page-content']}>
    <main>
      <section className={css['news-cover-stories']}>
        <FeaturedStories
          articleData={fromJS(articles)}
          css={css}
          fontAwesome={fontAwesome} />
      </section>
      {(articles.length >= MINIMUM_EXTRA_ARTICLES) && <section className={css['latest-articles']}>

        <h2>
          <FormattedMessage
            id="ui.label.title.NEWS_LATEST_ARTICLES"
            defaultMessage="latest articles"
            description="Section title that appears on the news page." />
        </h2>
        <div className={css['latest-news-articles']}>
          <LatestStories
            articleData={fromJS(articles)}
            css={css}
            fontAwesome={fontAwesome} />
        </div>
      </section>}
    </main>

    <aside>
      <GameUpdateList gameUpdates={gameUpdates} theme={css} />
    </aside>

  </div>;

  return (<Main globalSettings={content.globalSettings}>
    <DocumentTitle title={title} site={DOW} />
    <DocumentOpenGraphProperty property="url" value="https://www.dawnofwar.com/news" />
    <DocumentOpenGraphProperty property="title" value={title} />
    <DocumentOpenGraphProperty property="description" value={description} />
    <DocumentOpenGraphProperty property="image" value={items[items.length - 1].bannerPath} />
    <div key="news">
      <div className={css['content-panel']}>
        <div className={`${css['panel-content']} ${css.NewsPage}`}>
          <Tabs theme={css}
            currentTab={params.filter ? params.filter : DEFAULT_NEWS_TAB}
            onTabActivate={({tabName}) => {
              navActions.NavTo({
                view: 'news',
                transition: 'fade',
                returnTransition: 'fade',
                params: {filter: tabName},
              });
            }}>
            <Tab name="all" label="News">{sharedTabContents}</Tab>
            <Tab name="patches" label="Game Updates">{sharedTabContents}</Tab>
          </Tabs>
        </div>
      </div>
    </div>


  </Main>);
}



// WEBPACK FOOTER //
// ./apps/www.dawnofwar.com/src/views/news.jsx